import {ClsAccessToken} from '../cls-access-token';
import {ClsErrores} from '../cls-errores';
import {
  ClsCatalogoPresupuestos,
  ClsOrganizacion,
  ClsPresupuestos
} from '../cls-presupuestos';
import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsCliente} from '../cls-cliente';
import {EnumSocket} from '../enum/enum-socket';
import {EnumNivelNotificacion} from '../enum/enum-mas-opciones';

export class ClsPeticionCatalogoPpto extends ClsPeticionPresupuestos {
  TipoPresupuesto: number;
}

export class ClsRespuestaCatalogoPpto {
  LsPresupuetos: ClsCatalogoPresupuestos[];
  Errores: ClsErrores;
}

export class ClsRespuestaPresupuestos {
  Catalogo: string;
  Partidas: string;
  Presupuesto: string;
  CostosHorarios: string;
  CostosHorariosMO: string;
  CostosHorariosOC: string;
  Matrices: string;
  CostosCalculo: string;
  CostosOP: string;
  CostosMO: string;
  Errores: ClsErrores;
}
// crear, modificar, borrar ppto
export class ClsPeticionPresupuesto {
  AccessToken: ClsAccessToken;
  Presupuesto2021: ClsPresupuestos;
}

export class ClsPeticionPresupuestoActualiza {
  AccessToken: ClsAccessToken;
  IdPresupuesto: bigint;
  CodigoPresupuesto: string;
  NombrePresupuesto: string;
  IdEstado: bigint;
  IdCiudad: bigint;
  IdResponsable: bigint;
  IdCliente: bigint;
  IdEmpresa: bigint;
  IdVendedor: bigint;
  IdClienteContacto: bigint;
  Direccion: string;
  Colonia: string;
  CodPost: string;
  Telefono: string;
  EMail: string;
  Observaciones: string;
  Bloqueado: boolean;
  PorcentajeIVA: number;
  Cargo: string;
  TipoPresupuesto?: number;
  IdTipoLicitacion: bigint;
  FechaUltimaExportacion: Date;
  Region: string;
}

export class ClsRespuestaPresupuesto {
  AccessToken: string;
  IdOrganizacion: bigint;
  Presupuestos: ClsPresupuestos[];
  Errores: ClsErrores;
}

export class ClsRespuestaDetallePresupuesto {
  DetallePresupuesto: ClsPresupuestos;
  Errores: ClsErrores;
}

export class ClsPeticionBorrarPresupuesto extends ClsPeticionPresupuestos {
  IdOrganizacion: bigint;
}

export class ClsPeticionAddUpdateAgrupador extends ClsPeticionPresupuestos {
  Agrupador: string;
  NumAgrupador: number;
}
// organización
export class ClsRespuestaOrganizacion {
  Organizacion: ClsOrganizacion;
  Errores: ClsErrores;
}

// WebSocket
export class ClsSocket {
  Type: EnumSocket;
  Data?: any;
  Usuario?: ClsCliente;
}

export class ClsNotificaciones {
  Id?: string;
  Type?: EnumSocket;
  Mensaje?: string;
  Usuario?: ClsCliente;
  Fecha?: Date;
  UsuName?: string;
  UsuEmail?: string;
  UsuAvatar?: string;
  Name?: string;
  Email?: string;
  Picture?: string;
  IdPartida?: string;
  IdConcepto?: string;
  IdMatriz?: string;
  //   opciones para las notificaciones de las matrices pendientes de analisar
  Titulo?: string;
  SubTitulo?: string;
  Concepto?: string;
  Descripcion?: string;
  Unidad?: string;
  ObservacionPendiente?: string;
}

export class ClsNivelNotificaciones {
  Nivel: EnumNivelNotificacion;
  FechaCorta?: string;
  Notificaciones: ClsNotificaciones[];
}

export class ClsNotificacionesPenDeAnalisar {
  Notificaciones: ClsNotificaciones[];
}
